export enum FilterEnum {
  PRICES_INC_SHIPPING = 'showPricesInclShipping',
  PICKUP_ONLY = 'showPickupOnly',
  INTERNATIONAL = 'showInternational',
  UNAVAILABLE = 'showUnavailable',
}

export enum FilterType {
  PRODUCT_PRICE_TYPE = 'ProductPriceType',
  PRICE_LIST_SETTING = 'PricelistSetting',
}
